export function loadGoogleAdsScript(googleAdsTagId) {
  if (window && document?.documentElement?.firstChild) {
    const newScript = document.createElement('script');
    newScript.type = 'text/javascript';
    newScript.setAttribute('async', 'true');
    newScript.setAttribute(
      'src',
      `https://www.googletagmanager.com/gtag/js?id=${googleAdsTagId}`,
    );
    document.documentElement.firstChild.appendChild(newScript);
    newScript.onload = () => {
      const loadCheck = () => {
        if (!window.gtag) {
          window.dataLayer = window.dataLayer || [];
          window.gtag = function gtag() {
            window.dataLayer.push(arguments);
          };
        }
        window.gtag('js', new Date());
        window.gtag('config', googleAdsTagId, {
          send_page_view: false,
        });
        window.gtag('consent', 'default', {
          ad_storage: 'denied',
          analytics_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization: 'denied',
        });
      };
      setTimeout(() => {
        loadCheck();
      }, 500);
    };
  }
}

export function sendGoogleAdsLeadConversion(email, googleAdsDestinationId) {
  if (window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: googleAdsDestinationId,
      email,
    });
  }
}
